/* eslint-disable no-unused-vars */
import axios from 'axios';
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/offices`;

const state = {
    offices: [],
    selected_users: [],
    officeCount: null
};

const getters = {
    allOffices: state => state.offices,
    selectedUsers: state => state.selected_users,
    totalOfficeCount: state => state.officeCount
};

const actions = {
    async fetchOffices({ commit }, payload) {
        try {
            let page = payload.page || null
            let limit = payload.itemsPerPage
            if(limit == -1) {
                limit = 1000
            } 
            const url1 = url + "?page=" + page + "&limit=" + limit
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(url1, {
                headers: { 'x-drmms-token': authToken }
            });
            
            const offices = {
                count: response.data.count,
                rows: response.data.rows.map((office)=> ({
                    ...office,
                    users: office.users,
                    assigned_user: []
                }))
            }

            commit('setOffices', offices);
        } catch (err) {
            console.log(err);
        }
    },
    async createOffice({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(url, body, {
                headers: { 'x-drmms-token': authToken }
            });
            let office = response.data;
            office.assigned_users = [];
            office.users = [];
            console.log(office);
            commit('newOffice', office);
            return true;
        } catch (err) {
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 400) return { error: true, status: 500, message: 'Internal Server Error' };
            }
            console.log(err);
        }
    },
    async deleteOffice({ commit }, officeId) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.delete(`${url}/${officeId}`, {
                headers: { 'x-drmms-token': authToken }
            });
            console.log(officeId);
            commit('removeOffice', officeId);
            return response;
        } catch (err) {
            console.log(err);
        }
    },
    async deleteOffices({ commit }, ids){
        try {
            const authToken = localStorage.getItem('access_token')
            const response = await axios({
                method: "delete",
                url,
                headers: { 'x-drmms-token': authToken},
                data: { ids },
            })
            commit('removeOffice', ids)
            return response;
        } catch (err) {
            return { error: true, status: err.response.status, message: err.response.data }
        }
    },
    async updateOffice({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios({
                method: 'put',
                url: `${url}/${body.id}`,
                headers: { 'x-drmms-token': authToken },
                data: {
                    name: body.name,
                    location: body.location,
                    group_id: body.group_id
                }
            });
            if (response.data.groupUpdated) body.office_group = response.data.group;
            commit('updateOffice', body)
            return true;
        } catch (err) {
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 400) return { error: true, status: 500, message: 'Internal Server Error' };
            }
            console.log(err);
        }
    },
    async fetchUsersByOffice({ commit }, item) {
        if (item.assigned_user.length < 1) {
            const index = state.offices.findIndex(office => office.id === item.id);
            try {
                const authToken = localStorage.getItem('access_token');
                const response = await axios.get(`${url}/users/${item.id}`, { headers: { 'x-drmms-token': authToken } });

                const users = response.data;
                const pass = { users, index, item }

                commit('addAssignedUsers', pass)
            } catch (err) {
                console.log(err);
                if (err.response) {
                    if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                    else if (err.response.status == 400) return { error: true, status: 500, message: 'Internal Server Error' };
                }
            }
        } else {
            state.selected_users = item.assigned_users;
        }
    },
    async updateHeadUser({ commit }, body) {
        let req = {
            office_id: body.office.id,
            user_id: body.user.id
        }

        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios({
                method: 'put',
                url: `${url}/assignHead`,
                data: req,
                headers: { 'x-drmms-token': authToken }
            });

            let res = response.data;
            commit('updatedHeadUser', body);
            return true;
        } catch (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 400) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
    },
};

const mutations = {
    setOffices: (state, offices) => {
        state.offices = offices.rows;
        state.officeCount = offices.count;
        // console.log(state.count);  
        // console.log(state.offices);  
        // (state.offices = offices),
        // console.log(offices);

    }, 
    newOffice: (state, office) => state.offices.push(office),
    removeOffice: (state, id) => {
        for (let i = 0; i < id.length; i++) {
            state.offices = state.offices.filter(office => office.id !== id[i])
        }
    },
    updateOffice: (state, updOffice) => {
        const index = state.offices.findIndex(office => office.id === updOffice.id);
        if (index !== -1) {
            state.offices.splice(index, 1, updOffice);
        }
    },
    addAssignedUsers: (state, pass) => {
        let office = pass.item;
        office.assigned_users = pass.users;
        state.assigned_users = pass.users;
        if (pass.index !== -1) {
            state.offices.splice(pass.index, 1, office);
        }
        state.selected_users = pass.users;
    },
    updatedHeadUser: (state, data) => {
        const index = state.offices.findIndex(office => office.id === data.office.id);
        let selectedOffice = state.offices[index];
        let userArray = [];
        userArray.push(data.user);
        selectedOffice.users = userArray;

    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}